<template>
  <div class="course-wrapper">
    <div class="course-content">
      <div class="main-title">
        <span class="text" style="margin-right: 24px">推荐课程</span>
        <div class="link-list">
          <!-- <el-link
            :type="classId === id ? 'primary' : 'default'"
            class="category"
            v-for="{ id, name } in courseClasses"
            :key="id"
            :underline="false"
            href="javascript:;"
            @click="classId = id"
          >
            {{ name }}
          </el-link> -->
          注：此列表非全部课程
        </div>
        <a
          :href="`${$schoolUrl}/courseList.html`"
          class="more-btn"
          style="margin-top: 14px"
        >
          <span class="btn-text">查看全部</span>
          <i class="iconfont icongengduo"></i>
        </a>
      </div>
      <div class="course-list">
        <template v-if="homeCourseList && homeCourseList.length">
          <CourseCard
            class="home-course-card"
            :course-data="course"
            v-for="course in homeCourseList"
            :key="course.courseId"
            :show-label="true"
          >
          </CourseCard>
        </template>
        <EmptyIcon v-else type="course" text="暂无推荐课程"/>
      </div>
    </div>
  </div>
</template>
<script>
import CourseCard from "./../../components/CourseCard";
import EmptyIcon from "components/EmptyIcon"
export default {
  props: {
    courseType: Number,
  },
  created() {
    this.getCourseClassify();
    this.getHomeCourseList();
  },
  components: {
    CourseCard,
    EmptyIcon
  },
  data() {
    return {
      homeCourseList: [],
      courseCategorys: [],
      abbr: this.$config.abbr,
      classId: undefined,
    };
  },
  methods: {
    //获取课程分类
    async getCourseClassify() {
      const courseClasses = await this.$http.nuc.getCourseClassify();
      this.courseClasses = courseClasses || [];
    },
    async getHomeCourseList() {
      const classify_id = this.classId;
      const homeCourse = await this.$http.nuc.getHomeCourseList({
        classify_id,
      });
      this.homeCourseList = homeCourse.content;
    },
  },
  watch: {
    classId() {
      this.getHomeCourseList();
    },
  },
};
</script>

<style lang="scss" scoped>
.course-wrapper {
  margin-top: -242px;
  padding: 57px 0 24px;
  background: url("~assets/images/home/course_bg.png");
  background-size: cover;
  .course-content {
    width: 1200px;
    margin: 0 auto;
  }
}
.course-wrapper,
.notice-wrapper {
  vertical-align: top;
}

.course-wrapper {
  &:first-child {
    margin-bottom: 40px;
  }
}

.course-wrapper .course-list {
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
}
.home-course-card {
  width: 230px;
  & + .home-course-card {
    margin-left: 12px;
  }
  &:nth-of-type(5n + 1) {
    margin-left: 0;
  }
  &:nth-of-type(n + 6) {
    margin-top: 14px;
  }
}
.category {
  display: inline-block;
  max-width: 140px;
  & + .category {
    margin-left: 16px;
  }
}
.main-title {
  display: flex;
  max-height: 37px;
  overflow: hidden;
  padding-bottom: 10px;
  .link-list {
    flex: 1;
    margin-top: 6px;
    font-size: 14px;
    line-height: 24px;
  }
  .more-btn {
    flex: 0 0 72px;
  }
}
</style>